import React, {useEffect, useRef} from "react";
import classes from './SortyBy.module.scss';
import { useSortBy, UseSortByProps } from "react-instantsearch";

type SortByProps = {
  items: Item[];
  [x: string]: any;
};
interface Item {
  value: string;
  label: string;
  id: string;
  isRefined?: boolean;
}

const SortBy: React.FC<SortByProps> = ({ items }) => {
  const { refine, currentRefinement: sortBy } = useSortBy({
    items,
  } as UseSortByProps);
  const formRef = useRef<HTMLFormElement>(null);

  return (
    <>
      <form ref={formRef}>
        {items.map((item, index) => (
          <div
            key={`${item.label}-${index}`}
            className={classes.radioWrapper}
            onClick={() => refine(item.value)}
          >
            <input
              defaultChecked={
                item.value === sortBy
              }
              className={classes.sortRadio}
              id={item.id}
              name="sort"
              type="radio"
            />
            <label htmlFor={item.id} className={classes.sortLabel}>
              {item.label}
            </label>
          </div>
        ))}
      </form>
    </>
  );
};

const connectedSortBy = connectSortBy(SortBy);

export default connectedSortBy;

// TODO (Codemod generated): ensure your usage correctly maps the props from the connector to the hook
function connectSortBy(Component: React.FC<SortByProps>) {
  const SortBy = (props: SortByProps) => {
    const data = useSortBy(props);

    return <Component {...props} {...data} />;
  };

  return SortBy;
}